// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1pphI","addWidgetButton":"Header_addWidgetButton__2J6_a","dashboardTabs":"Header_dashboardTabs__1WRg1","active":"Header_active__3sWAY"};